<template lang="pug">
  .radio(:class="{ checked }" @click="click")
</template>

<script>
export default {
  name: 'BaseRadio',
  props: {
    checked: Boolean,
  },
  methods: {
    click() {
      this.$emit('click');

      if (!this.checked) {
        this.$emit('check');
      }
    },
  },
};
</script>

<style scoped lang="scss">
  .radio {
    border: 1px solid #D1D9F0;
    border-radius: 100%;
    width: 20px;
    height: 20px;
    cursor: pointer;

    &.checked {
      border: 1px solid #33A1FB;
      position: relative;

      &:before {
        position: absolute;
        content: '';
        display: block;
        background: #33A1FB;
        top: 25%;
        left: 25%;
        right: 25%;
        bottom: 25%;
        border-radius: 100%;
      }
    }
  }
</style>
